import $ from 'jquery'

import formatData    from './formatData'
import { showError } from '../render/errors'

const getTypes = callback => {

  const data = {
          action   : 'your-chat/get-qnatypes',
          security : window.your_chat.ajax_nonce,
        }

  $.post( ajaxurl, data )

   .done( response => {

      if ( !response.success )
        return showError( response.message );

      if ( typeof callback === 'function' )
        callback( formatData( response.data ) )

   } )

   .fail( ( xhr, status, error ) => showError() )

}

export default callback => getTypes( callback )
